import React from 'react';
import { Layout } from 'react-admin';
import TreeMenu from '@bb-tech/ra-treemenu';

const MyLayout = (props) => <Layout
    {...props}
    menu={TreeMenu}
/>;

export default MyLayout;